import { notification } from "antd";

import { IRetailMatchJob } from "../../../Models/IRetailMatch";
import { IRetailMatchGeography } from "../../../Models/IRetailMatchGeography";
import { MatchReportTypeEnum } from "../Enums/MatchReportTypeEnum";
import {
    GET_RETAIL_MATCH_GEOGRAPHIES_FAILURE,
    GET_RETAIL_MATCH_GEOGRAPHIES_SUCCESS,
    IGNORE_RUNNING_REPORT,
    RESET_RETAIL_MATCH_ACTION,
    RESTART_RETAIL_MATCH_ACTION,
    RetailMatchActionType,
    SearchedPlaceInfo,
    SET_CHECKING_SITE_IS_IN_DMA,
    SET_INCLUDE_ALL_BUDS_ACTION,
    SET_LOADING_MATCH_REPORT,
    SET_LOADING_RETAIL_MATCH_GEOGRAPHIES,
    SET_MATCH_REPORT_TYPE,
    SET_MOST_RECENTLY_SUBMITTED_RETAIL_MATCH_REPORT,
    SET_SEARCHED_PLACE_MATCH_ACTION,
    SITE_IS_IN_DMA_SUCCESS,
    START_LAST_REPORT_RUNNING,
    SUBMIT_MATCH_REPORT_SUCCESS,
} from "../Types/RetailMatchActionTypes";

export interface IRetailMatchReducerState {
    retailMatchGeos: IRetailMatchGeography[];
    loadingRetailMatchGeos: boolean;
    searchedPlaceIndex: number;
    searchedPlaceName: string;
    searchedPlaceId: string;
    searchedPlaceLat: number;
    searchedPlaceLng: number;
    matchReportType: MatchReportTypeEnum;
    loadingReport: boolean;
    lastReportName: string;
    lastReportRunning: boolean;
    resetCount: number;
    includeAllBuds: boolean;
    mostRecentSubmittedReport: IRetailMatchJob;
    siteIsInDMA: boolean;
    isCheckingSiteIsInDMA: boolean;
}

export const retailMatchReducerState: IRetailMatchReducerState = {
    retailMatchGeos: [],
    loadingRetailMatchGeos: false,
    searchedPlaceIndex: 0,
    searchedPlaceName: null,
    searchedPlaceId: null,
    searchedPlaceLat: 0,
    searchedPlaceLng: 0,
    matchReportType: MatchReportTypeEnum.DEFAULT,
    loadingReport: false,
    lastReportName: null,
    lastReportRunning: false,
    resetCount: 0,
    includeAllBuds: true,
    mostRecentSubmittedReport: null,
    siteIsInDMA: false,
    isCheckingSiteIsInDMA: false,
};

export const retailMatchReducer = (
    state: IRetailMatchReducerState = { ...retailMatchReducerState },
    action: RetailMatchActionType
): IRetailMatchReducerState => {
    switch (action.type) {
    /** misc */
        case SET_MOST_RECENTLY_SUBMITTED_RETAIL_MATCH_REPORT: {
            return {
                ...state,
                mostRecentSubmittedReport: action.data as IRetailMatchJob | null
            };
        }
        case SET_SEARCHED_PLACE_MATCH_ACTION: {
            const searchedPlace = action.data as SearchedPlaceInfo;
            return {
                ...state,
                searchedPlaceIndex: state.searchedPlaceIndex + 1,
                searchedPlaceName: searchedPlace.name,
                searchedPlaceId: searchedPlace.placeId,
                searchedPlaceLat: searchedPlace.lat,
                searchedPlaceLng: searchedPlace.lng,
                resetCount: state.resetCount + 1,
                lastReportRunning: false,
            };
        }
        case START_LAST_REPORT_RUNNING: {
            return {
                ...state,
                lastReportName: action.data as string,
                lastReportRunning: true,
            };
        }
        case IGNORE_RUNNING_REPORT: {
            return {
                ...state,
                lastReportRunning: false,
            };
        }
        case SET_INCLUDE_ALL_BUDS_ACTION: {
            return {
                ...state,
                includeAllBuds: action.data as boolean,
            };
        }
        case RESET_RETAIL_MATCH_ACTION: {
            return {
                ...retailMatchReducerState,
                retailMatchGeos: state.retailMatchGeos,
                searchedPlaceIndex: state.searchedPlaceIndex,
                lastReportName: state.lastReportName,
                resetCount: state.resetCount + 1,
            };
        }
        case RESTART_RETAIL_MATCH_ACTION: {
            return {
                ...retailMatchReducerState,
                retailMatchGeos: state.retailMatchGeos,
                searchedPlaceIndex: state.searchedPlaceIndex,
                lastReportName: state.lastReportName,
                resetCount: state.resetCount + 1,
                searchedPlaceName: state.searchedPlaceName,
                searchedPlaceId: state.searchedPlaceId,
                searchedPlaceLat: state.searchedPlaceLat,
                searchedPlaceLng: state.searchedPlaceLng,
            };
        }
        case SET_LOADING_RETAIL_MATCH_GEOGRAPHIES: {
            return {
                ...state,
                loadingRetailMatchGeos: action.data as boolean,
            };
        }
        case SET_MATCH_REPORT_TYPE: {
            return {
                ...state,
                matchReportType: action.data as MatchReportTypeEnum,
            };
        }
        case SET_LOADING_MATCH_REPORT: {
            return {
                ...state,
                loadingReport: action.data as boolean,
            };
        }
        /** success */
        case GET_RETAIL_MATCH_GEOGRAPHIES_SUCCESS: {
            return {
                ...state,
                retailMatchGeos: action.data as IRetailMatchGeography[],
            };
        }
        case SUBMIT_MATCH_REPORT_SUCCESS: {
            return {
                ...state,
                mostRecentSubmittedReport: action.data as IRetailMatchJob
            };
        }
        /** failure */
        case GET_RETAIL_MATCH_GEOGRAPHIES_FAILURE: {
            notification.error({
                message: "Error getting Retail Match geographies",
                description: action.data,
            });
            return state;
        }
        case SITE_IS_IN_DMA_SUCCESS: {
            return {
                ...state,
                siteIsInDMA: action.data as boolean
            };
        }
        case SET_CHECKING_SITE_IS_IN_DMA: {
            return {
                ...state,
                isCheckingSiteIsInDMA: action.data as boolean
            };
        }
                
        default: {
            return state;
        }
    }
};
